/**
 * @module profile/components/brief/legacy
 */
import React, { PropTypes } from 'react';
import anchorme from 'anchorme';
import { ANCHORME_OPTIONS } from 'pap/components/common/answer_renderers';


class LegacyBriefSection extends React.Component {
  render() {
    return (
      <section className="row brief-section">
        <div className="small-16 large-4 columns brief-title">
          <h2>{ this.props.section.label }</h2>
        </div>
        <div className="small-16 large-8 columns brief-content">
        {this.props.section.questions.map((question, index) => {
           const linesWithLinks = (question.value || '').split('\n').map((line, key) => {
             const textWithAnchors = anchorme(line, ANCHORME_OPTIONS) + "<br/>";
             return <span key={key} dangerouslySetInnerHTML={{__html: textWithAnchors}}/>;
           })

           return (
             <div className="item" key={index}>
               <h5>{ question.label }</h5>
               <p>{ linesWithLinks }</p>
             </div>
           )
        })}
        </div>
      </section>
    );
  }
}

class LegacyBriefSimplified extends React.Component {
  render() {
    let briefLines = this.props.brief_text.split(/\r\n|\r|\n/g).filter(i => i.trim().length > 0);

    return (
      <section className="row brief-background">
        <div className="small-16 large-9 columns brief-content brief-legacy">
          { briefLines.map((line, index) => {
              var lineWithLinks = anchorme(line, ANCHORME_OPTIONS);
              // title line ?
              if (index % 2 === 0 && line.indexOf("http") < 0 && (line[line.length-1] == ":" || line[line.length - 1] === "?" || line[line.length-1] === ")")) {
                return <h4 dangerouslySetInnerHTML={{__html: lineWithLinks}} key={index}/>
              } else {
                return <p dangerouslySetInnerHTML={{__html: lineWithLinks}} key={index}/>
              }
          })}
        </div>
      </section>
    );
  }
}

/**
 * A component for displaying brief of the legacy (migrated) projects.
 */
class LegacyBrief  extends React.Component {

  render() {
    const { project } = this.props;

    if (this.props.showNDAd) {
      return (
        <div className="brief-legacy">
            { project.brief_answers.description }
        </div>
      );
    }

    return (
      <div className="brief-legacy">
      {project.brief_answers.legacy_brief_sections &&
        project.brief_answers.legacy_brief_sections.map((section, index) => {
          return <LegacyBriefSection section={section} key={index} />
        })
      }
      {project.brief_answers.legacy_brief_sections.length == 0 &&
          <LegacyBriefSimplified brief_text={project.brief_answers.legacy_brief_text} />}
      </div>
    );
  }
};

LegacyBrief.propTypes = {
  project: PropTypes.object,
};

export default LegacyBrief;



// WEBPACK FOOTER //
// ./project/components/brief/legacy.jsx